import { render } from "./TransitionExpand.vue?vue&type=template&id=885dd136&scoped=true"
import script from "./TransitionExpand.vue?vue&type=script&lang=js"
export * from "./TransitionExpand.vue?vue&type=script&lang=js"

import "./TransitionExpand.vue?vue&type=style&index=0&id=885dd136&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-885dd136"]])

export default __exports__